module.exports = "<div class=\"app l-app\">\n\t<div\n\t\t:class=\"layoutSidebarClasses\"\n\t\tv-if=\"showSidebar\">\n\t\t<qd-sidebar/>\n\t</div>\n\n\t<div\n\t\t:class=\"layoutInnerClasses\">\n\t\t<router-view\n\t\t\t:app-loaded=\"appLoaded\"\n\t\t\t:key=\"$route.meta.postId\"/>\n\t</div>\n\n\t<transition name=\"fade\">\n\t\t<qd-loading-screen v-if=\"!appLoaded\"/>\n\t</transition>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/app.vhtml
// module id = 415
// module chunks = 0